import React from "react";
import HomeShadowCard from "../HomeShadowCard/HomeShadowCard";
import { baseUrl } from "../../utils/base_url";
import { useMediaQuery } from "react-responsive";
import {
  _1200px,
  _1400px,
  _1500px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
} from "../../utils/mediaBreakpoints";
import { useNavigate } from "react-router-dom";

const HomeFourth = ({
  isMobile,
  imgsrc,
  heading,
  subHeading,
  btnClass,
  cards,
  cardwidth,
  cardheight,
}) => {
  console.log(btnClass);
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  const navigate = useNavigate();
  console.log(_1500, "1500");

  return (
    <>
      <div
        className="container-fluid m-0 p-0"
        style={{ backgroundColor: " #090D23" }}
      >
        <div className="container px-0 contwidth">
          <div className="row py-5">
            <div className="col-md-6">
              <div
                className="rounded-4"
                style={{
                  backgroundColor: " #D9D9D9",
                  width: _1800 ? "100%" : "750px",
                  height: _1800 ? "max-content" : "557px",
                }}
              >
                {imgsrc?.mime?.includes("video") ? (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                    }}
                  >
                    <video
                      autoPlay
                      loop
                      muted
                      className=""
                      style={{
                        objectFit: "cover",
                        height: "100%",
                        width: "100%",
                        // borderRadius: "20px",
                      }}
                    >
                      <source
                        src={`${baseUrl}${imgsrc?.url}`}
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                ) : (
                  <img
                    className="d-block"
                    style={{
                      objectFit: "cover",
                      width: "100%",
                      height: "100%",
                      // borderRadius: "20px",
                    }}
                    src={`${baseUrl}${imgsrc?.url}`}
                    alt="..."
                  />
                )}
              </div>
              {/* <img src={`${baseUrl}${imgurl}`} alt="no image" /> */}
            </div>
            <div className="col-md-6 d-flex align-items-center">
              <div className="d-flex flex-column text-white">
                <p
                  className="fw700 lh-1 pt-5 pt-md-0"
                  style={{
                    fontSize: _576
                      ? "35px"
                      : _768
                        ? "45px"
                        : _992
                          ? "32px"
                          : _1200
                            ? "38px"
                            : _1400
                              ? "42px"
                              : _1500
                                ? "45px"
                                : _1600
                                  ? "47px"
                                  : _1700
                                    ? "50px"
                                    : _1800
                                      ? "55px"
                                      : "60px",
                  }}
                >
                  {heading}
                </p>
                <p
                  className="fw500 lh-sm"
                  style={{
                    fontSize: _576
                      ? "16px"
                      : _768
                        ? "20px"
                        : _992
                          ? "16px"
                          : _1200
                            ? "18px"
                            : _1400
                              ? "20px"
                              : _1500
                                ? "20px"
                                : _1600
                                  ? "23px"
                                  : _1700
                                    ? "23px"
                                    : _1800
                                      ? "26px"
                                      : "26px",
                  }}
                >
                  {subHeading}
                </p>
              </div>
            </div>
            <div className="col-12 py-5">
              <div className="row">
                {cards.map((item, index) => {
                  return (
                    <>
                      <div key={index} className={btnClass}>
                        <div
                          onClick={() => {
                            navigate(item?.link);
                          }}
                          style={{ width: "100%", cursor: "pointer", height: cardheight }}
                        >
                          <HomeShadowCard
                            isMobile={isMobile}
                            icon={item?.image?.url}
                            heading={item?.heading}
                            rightcorner={item?.right_corner_color}
                            shadow={`0 0 20px ${item?.shadow}`}
                            background={item?.backgroundColor}
                          />
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeFourth;
